module.exports = __webpack_public_path__ + "static/Green Story-52f7402ac75394610a3fc4f6dfdc3879.jpg";